import { Navigate, createBrowserRouter } from 'react-router-dom'
import { RouterPaths } from './RouterPaths'
import { Auth, ElementWrapper, ListenLocation } from './templates'

const toRouteKey = (path: string, base?: string) => {
  const key = base && path.startsWith(base) ? path.replace(base, '') : path
  return key.startsWith('/') ? key.slice(1) : key
}

export default createBrowserRouter([
  {
    path: '*',
    element: <ListenLocation />,
    children: [
      // 未ログイン、背景なし
      {
        path: '*',
        element: <ElementWrapper isBackgroundImage={false} />,
        children: [
          { path: toRouteKey(RouterPaths.Login), lazy: () => import('src/pages/Login') },
          { path: toRouteKey(RouterPaths.Maintenance), lazy: () => import('src/pages/Maintenance') },
        ],
      },

      // 未ログイン、背景あり
      {
        path: '*',
        element: <ElementWrapper isBackgroundImage />,
        children: [
          {
            path: `${toRouteKey(RouterPaths.Signup.Base)}/*`,
            children: [
              {
                path: toRouteKey(RouterPaths.Signup.Form, RouterPaths.Signup.Base),
                lazy: () => import('src/pages/Signup/Form'),
              },
              {
                path: toRouteKey(RouterPaths.Signup.PaymentMethodCompletion, RouterPaths.Signup.Base),
                lazy: () => import('src/pages/Signup/Completion'),
              },
              // no match
              { path: '*', element: <Navigate replace to={RouterPaths.Home} /> },
            ],
          },
          {
            // /signup に移行した
            // お客さんにQRで配っているので、当分はリダイレクト処理を残す
            path: `dormitory/*`,
            children: [
              {
                path: '*',
                element: <Navigate replace to="/signup" />,
              },
            ],
          },
          { path: toRouteKey(RouterPaths.FAQ), lazy: () => import('src/pages/FAQ') },
          { path: toRouteKey(RouterPaths.PasswordMail), lazy: () => import('src/pages/PasswordMail') },
          { path: toRouteKey(RouterPaths.RegisterPassword), lazy: () => import('src/pages/RegisterPassword') },
          { path: toRouteKey(RouterPaths.ResetPassword), lazy: () => import('src/pages/ResetPassword') },

          { path: toRouteKey(RouterPaths.InvoiceSample), lazy: () => import('src/pages/InvoiceSample') },
        ],
      },

      // ログイン必須
      {
        path: '*',
        element: <Auth />,
        children: [
          { index: true, lazy: () => import('src/pages/Home') },

          { path: toRouteKey(RouterPaths.Consumptions), lazy: () => import('src/pages/ConsumptionChart') },
          { path: toRouteKey(RouterPaths.EVInvoices), lazy: () => import('src/pages/EVInvoice') },
          { path: toRouteKey(RouterPaths.GasConsumptions), lazy: () => import('src/pages/GasConsumptionChart') },
          { path: toRouteKey(RouterPaths.Inquiry), lazy: () => import('src/pages/Inquiry') },
          { path: toRouteKey(RouterPaths.Invoices), lazy: () => import('src/pages/Invoice') },
          { path: toRouteKey(RouterPaths.PaymentMethod), lazy: () => import('src/pages/PaymentMethod') },
          { path: toRouteKey('/payment/request'), element: <Navigate replace to={RouterPaths.PaymentMethod} /> },
          { path: toRouteKey(RouterPaths.Receipts), lazy: () => import('src/pages/Receipts') },
          {
            path: `${toRouteKey(RouterPaths.User.Base)}/*`,
            children: [
              {
                path: toRouteKey(RouterPaths.User.Edit, RouterPaths.User.Base),
                lazy: () => import('src/pages/User/Edit'),
              },
              {
                path: toRouteKey(RouterPaths.User.MoveOut, RouterPaths.User.Base),
                lazy: () => import('src/pages/User/MoveOut'),
              },
              // no match
              { path: '*', element: <Navigate replace to={RouterPaths.Home} /> },
            ],
          },
          // no match
          { path: '*', element: <Navigate replace to={RouterPaths.Home} /> },
        ],
      },

      // 旧システムからの移行用
      {
        path: toRouteKey('/webinfo/student/building_confirm'),
        element: <Navigate replace to={RouterPaths.Signup.Form} />,
      },
    ],
  },
])
